import logo from "../../../../../assets/appIcon.png"
import styles from "./styles.module.scss"
import classNames from "classnames"
import { ErrorHandledImage } from "../../../../atoms/ErrorHandledImage"

const FormStepCard = ({
  image,
  title,
  description,
  children,
  currentStepIndex,
}: {
  image: string
  title: string
  description?: string
  children?: React.ReactNode
  currentStepIndex: number
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.textSectionWithImage}>
        <img alt="cruisen logo" src={logo} className={styles.logoImage} />
        <h2 className={classNames(styles.title, !description && styles.titleWithMargin)}>
          {title}
        </h2>

        {description ? <p className={styles.description}>{description}</p> : null}
        <div className={styles.progressBar}>
          {[...Array(5)].map((_, index) => (
            <div key={`space-${index + 1}`} className={styles[`progressBarSpace${index + 1}`]} />
          ))}
          <div className={styles.progressBarFill1} />
          {[...Array(5)].map((_, index) => (
            <div
              key={`fill-${index + 2}`}
              className={classNames(
                styles[`progressBarFill${index + 2}`],
                currentStepIndex >= index + 1
                  ? styles[`progressBarFill${index + 2}Active`]
                  : styles[`progressBarFill${index + 2}Inactive`],
              )}
            />
          ))}
        </div>

        <div className={styles.formContainer}>{children}</div>
      </div>
      <div className={styles.imageSection}>
        <ErrorHandledImage className={styles.sectionImage} uri={image} alt="Cruise sailing image" />
      </div>
    </div>
  )
}

export default FormStepCard
